// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"165":"shorts","464":"search","809":"account","922":"edit"}[chunkId] + "." + {"165":"19aab387","464":"374e16f4","809":"1bba8cb0","922":"db99b866"}[chunkId] + ".css";
};